import React, { Component, PropTypes } from 'react'
import Sidebard from '../../components/Sidebard'
// import { connect } from 'react-redux'
import './style.scss'
import { bootsrapColours, statuses, base, CScolours } from '../../../config'
import { objCleaner, getMonths } from '../../helpers'
import DatePicker from 'react-16-bootstrap-date-picker'
import Filters from '../../components/Filters'
import TaxReturn from '../../components/TaxReturn'
import JobSorter from '../../components/JobSorter'

import ChartBar from '../../components/ChartBar'
import ChartLine from '../../components/ChartLine'

import Form from "react-jsonschema-form"
import moment from 'moment'
import * as _ from 'lodash'

function rand(min, max, num) {
  var rtn = [];
  while (rtn.length < num) {
    rtn.push((Math.random() * (max - min)) + min)
  }
  return rtn
}

let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

const schema = {
  type: "object",
  required: ["label"],
  properties: {
    start: { "type": "string", "format": "date", "title": "Start Date" },
    end: { "type": "string", "format": "date" , "title": "End Date" }
  }
}

const schemaUi = {
  start: { "classNames": "col-xs-6"},
  end: { "classNames": "col-xs-6"}
}

function dateRange(startDate, endDate) {
  var start      = startDate.split('-');
  var end        = endDate.split('-');
  var startYear  = parseInt(start[0]);
  var endYear    = parseInt(end[0]);
  var dates      = [];

  for(var i = startYear; i <= endYear; i++) {
    var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
    var startMon = i === startYear ? parseInt(start[1])-1 : 0;
    for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
      var month = j+1;
      var displayMonth = month < 10 ? '0'+month : month;
      dates.push(monthNames[parseInt(displayMonth)-1])
    }
  }
  return dates;
}

export class Report extends Component {

    constructor(props) {
        super(props);
        this.state = {
          filter: ['quote', 'confirmed', 'invoiced', 'paid'],
          tab: 0,
          jobs: [],
          _taxReturn: false,
          startDate: new Date(moment().startOf('year').format('YYYY-MM-DD')).toISOString(),
          endDate: new Date(moment().startOf('nextYear').add('years', 1).format('YYYY-MM-DD')).toISOString(),
          formData: {
            start:'2017-12-01',
            end: "2018-06-01"
          }
        }
    }

    _filter (filter, check) {
      let filteredAry = []
      if (check) {
        filteredAry = this.state.filter.filter(function(e) { return e !== filter })
      }
      if (!check) {
        let fil = this.state.filter
        fil.push(filter)
        filteredAry = fil
      }
      this.setState({filter: filteredAry})
    }

    _getJobs () {
      base.fetch(`user_details/${this.props.uid}/jobs`, {
          context: this,
          asArray: true,
          queries: {
            orderByChild: 'start',
            startAt: this.state.startDate,
            endAt: this.state.endDate
          },
          then(data){
            this.setState({
              jobs: data
            })
          }
      })
    }

    onStartChange (startDate, endDate) {
      this.setState({startDate, endDate})
      setTimeout(() => {this._getJobs()}, 5)
    }


    componentDidMount () {
      this._getJobs()
    }

    _change (event) {
      this.setState({
        formData: event.formData
      })
      this._getJobs()
    }

    _taxReturn () {
      this.setState({taxReturn: !this.state.taxReturn})
    }

    render() {

        let jobs = this.state.jobs

        if (this.state.filter !== 'all') jobs = jobs.filter((job) => {
          if (this.state.filter.includes(job.selected_status.value)) return job
        })

        let chart = {
         dates: jobs.map((job) => (job.start)),
         data: jobs.map((job) => (job.total))
        }

        let groupByMonth = {};
        let months = [];
        let totals = [];

        chart.dates.map((d, i) => {
            var chartData = chart.data[i]
            var monthYear = moment(d).format('MMM YY')
            if (groupByMonth.hasOwnProperty(monthYear)) groupByMonth[monthYear].push(chartData)
            if (!groupByMonth.hasOwnProperty(monthYear)) groupByMonth[monthYear] = [chartData]
        })

        const chartLabels = getMonths(this.state.startDate, this.state.endDate)

        let groupByMonth2 = {}

        let saleColours = []
        let costColours = []


        chartLabels.map(label => {
          saleColours.push(bootsrapColours.danger)
          costColours.push(bootsrapColours.info)
          if (groupByMonth[label]) groupByMonth2[label] = groupByMonth[label]
          if (!groupByMonth[label]) groupByMonth2[label] = [{cost: "0", sale: "0"}]
        })

        const cost = Object.keys(groupByMonth2).map(key => {
          return groupByMonth2[key].map(item => (Number(item.cost))).reduce((a, b) => Number(a) + Number(b), 0)
        })

        const sale = Object.keys(groupByMonth2).map(key => {
          return groupByMonth2[key].map(item => (Number(item.sale))).reduce((a, b) => Number(a) + Number(b), 0)
        })

        const profit = Object.keys(groupByMonth2).map(key => {
          return Number(groupByMonth2[key].map(item => (Number(item.sale))).reduce((a, b) => Number(a) + Number(b), 0))-Number(groupByMonth2[key].map(item => (Number(item.cost))).reduce((a, b) => Number(a) + Number(b), 0))
        })

        let saleAndCostData = {
          labels: chartLabels,
          datasets: [
            { label: "Cost", data: cost, backgroundColor: saleColours},
            { label: "Sale", data: sale, backgroundColor: costColours}
          ]
        }

        const ChartBarData  = saleAndCostData.labels.map((item, index) => {
          const cost  = saleAndCostData.datasets[0].data[index] ? saleAndCostData.datasets[0].data[index] : 0
          const sale  = saleAndCostData.datasets[1].data[index] ? saleAndCostData.datasets[1].data[index] : 0
          return {
            "tabs": item,
            "Cost": cost,
            "Sale": sale,
            "Profit": sale - cost
          }
        })

        const totalSale = sale.map(item => Number(item)).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)
        const totalCost = cost.map(item => Number(item)).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)
        const totalProfit = (totalSale - totalCost).toFixed(2)

        let dataProfit  = {
          labels: chartLabels,
          datasets: [
              { label: "Profit", data: profit, backgroundColor: bootsrapColours.success }
          ]
        }

        dataProfit  = dataProfit.labels.map((item, index) => {
          return {
            "tabs": item,
            "Profit": dataProfit.datasets[0].data[index] ? dataProfit.datasets[0].data[index] : 0
          }
        })

        console.log(dataProfit)

        const dataSalesGrowth  = {
          labels: chartLabels,
          datasets: [
              { label: "SalesGrowth", data: profit }
          ]
        }

        const filters = statuses.map((item, index) => {
          const active = this.state.filter === item.value ? 'btn-warning' : 'btn-primary'
          return (
            <div key={index} className="btn-group" role="group">
              <button key={`filter${index}`} onClick={this._filter.bind(this, item.value)} type="button" className={`btn btn-primary ${active}`}>{item.label}</button>
            </div>
          )
        })

        const maxProf = _.maxBy(dataProfit, 'Profit').Profit
        const maxChartBarData = _.maxBy(ChartBarData, 'Sale').Sale


        return (
          <div className='report with-sidebar main-pt full-width-page'>

            <div className='row m-b-lg'>
              <div className="col-sm-4 col-md-3 ">
                <JobSorter
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onStartChange={this.onStartChange.bind(this)}
                   _filter={this._filter.bind(this)}
                   filter={this.state.filter}
                   showFilter
                   profit={totalProfit}
                   cost={totalCost}
                   sale={totalSale}
                />
              </div>


              {!this.state.taxReturn &&
                <div className='col-sm-8 col-md-9'>



                  <div className='panel'>
                    <div className='panel-heading'>
                      Sale & Cost
                    </div>
                    <div className='panel-body'>
                      <ChartBar height={300} maxValue={maxChartBarData + (maxChartBarData/10)} data={ChartBarData} keys={["Cost","Sale", "Profit"]} colors={CScolours} />
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-sm-12'>
                      <div className='panel'>
                        <div className='panel-heading'>
                          Profit & Loss
                        </div>
                        <div className='panel-body'>
                          <ChartBar height={300} maxValue={maxProf + (maxProf / 10)} data={dataProfit} keys={["Profit"]} colors={[CScolours[2]]} />
                        </div>
                      </div>
                    </div>
                    <div className='col-sm-5 hidden'>
                      <div className='panel'>
                        <div className='panel-heading'>
                          Profit & Loss
                        </div>
                        <div className='panel-body'>
                          <ChartBar height={300} maxValue={maxProf + (maxProf / 10)} data={dataProfit} keys={["Profit"]} colors={[CScolours[2]]} />
                        </div>
                      </div>
                    </div>
                  </div>






                  <div className='panel hidden'>
                    <div className='panel-heading'>
                      Sales & Growth
                    </div>
                    <div className='panel-body'>
                      <ChartLine height={300}/>
                    </div>
                  </div>



                 </div>
               }

            </div>

          </div>
        )
    }
}

// function mapStateToProps (state, ownProps) {
//   return {
//     sheets: state.finance.sheets
//   }
// }
//
// const mapDispatchToProps = (dispatch, ownProps) => {
//   return {
//     setOutgoing: (data) => {
//       dispatch(setOutgoing(data))
//     }
//   }
// }

export default Report
// connect(mapStateToProps, mapDispatchToProps)(Report)



// WEBPACK FOOTER //
// ./src/views/pages/Report/index.js